module.exports = __webpack_public_path__ + "media/Audio17_b.92752f62.wav";